import type { Cache, ResolveInfo } from '@urql/exchange-graphcache';
import { ORGANIZATION_PEOPLE_CACHE_FIELDS } from '@/client/exchanges/cacheExchange/constants';
import invalidateFields from '@/client/exchanges/cacheExchange/invalidateFields';

export default function insert_person_team(
  _parent: unknown,
  _args: unknown,
  cache: Cache,
  _info: ResolveInfo,
) {
  invalidateFields(
    [
      'team',
      'team_by_pk',
      'person_team',
      'person_team_aggregate',
      ...ORGANIZATION_PEOPLE_CACHE_FIELDS,
    ],
    cache,
  );
}
